import { getSystemSettings } from "./SettingsRetriever";

const TaxesAndFeesText = (element) => {
  const taxPriceConfig = getSystemSettings() && getSystemSettings().app && getSystemSettings().app.taxPriceText;
  if (!taxPriceConfig || !taxPriceConfig.enabled) return;
  /* the following if is for Lutsen temporal solution */
  if (taxPriceConfig && taxPriceConfig.temporalForcedEnabled && taxPriceConfig.temporalForcedText) {
    return <div style={{ fontSize: 12 }} className="avg">
      {taxPriceConfig.temporalForcedText}
    </div>
  }
  const { FeeInclusive = false , TaxInclusive = false } = element && element.PriceDetail ? element.PriceDetail : {};
  let taxPriceText = "";
  if (!FeeInclusive && !TaxInclusive) taxPriceText = "Taxes & fees are not included";
  if (!FeeInclusive && TaxInclusive) taxPriceText = "Including taxes";
  if (FeeInclusive && !TaxInclusive) taxPriceText = "Including fees";
  if (FeeInclusive && TaxInclusive) taxPriceText = "Including taxes & fees";
  return (
    <div className="avg">
      {taxPriceText}
    </div>
  )
}

export default TaxesAndFeesText;